import { CartAddEvent } from '@theme/events';

if (!customElements.get('luxe-gift-box')) {
  customElements.define('luxe-gift-box', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('submit', this.addGift, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    addGift = async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      if (this.pending) return;
      const button = form.querySelector('button[type="submit"]');
      const status = this.querySelector('[role="status"]');
      if (!button || button.disabled) return;
      this.pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.hidden = true;
      const data = new FormData(form);
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
      if (sections.length) data.set('sections', sections.join(','));
      data.set('sections_url', location.pathname);
      try {
        const response = await fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        status.textContent = this.dataset.success;
        status.hidden = false;
        this.dispatchEvent(new CartAddEvent(result, form.id, { source: 'luxe-gift-box', variantId: data.get('id'), itemCount: Number(data.get('quantity')), sections: result.sections }));
      } catch (error) {
        status.textContent = error instanceof Error ? error.message : this.dataset.error;
        status.hidden = false;
      } finally {
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };
  });
}
